export const removeNonDigits = (str: string) => str.replace(/[^-\d.]/g, "");
